import {PerformanceDefaults} from "./performance-defaults";

export class EntityPerformanceDefaults {

  entityId: string = '';
  entityRevision: number = 0;
  performanceDefaults!: PerformanceDefaults;

}
